// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__4-ts_","tab":"Tabs_tab__Bt7Lo","tabActive":"Tabs_tabActive__3ey0D"};